import { useApollo } from '/@src/composable/useApi'
import { productsDocument } from '/@src/api/productRepo'
import { ref } from 'vue'

type pagination = {
  first?: number
  offset?: number
}

type spec_attrs = {
  key?: string
  value?: string
}

interface QueryProductsParams {
  track?: string
  onSale?: boolean
  pagination: pagination
}
interface Item {
  name?: string
  id?: number
  cover_uri?: string
  price?: number
  spec_attrs?: spec_attrs
  platforms: string[]
}

export default function useProducts() {
  const graph = useApollo()
  const productList = ref({})
  const products = ref([])
  /*
   * 获取优惠券列表
   * */
  const queryProducts = async (params: QueryProductsParams) => {
    const res = await graph.query({
      query: productsDocument,
      variables: params,
    })
    productList.value = {
      ...res.data.skus,
      nodes: res.data.skus.nodes.filter(
        (x: Item) => !x.platforms.includes('IOS_IAP')
      ),
    }
    products.value = productList.value.nodes.slice(0, 10)
  }

  const splitProductsLimit = (limit: number) => {
    products.value = productList.value.nodes.slice(limit, limit + 10)
  }

  return {
    queryProducts,
    products,
    productList,
    splitProductsLimit,
  }
}
